export default function stepper({ variables }) {
    return {
        MuiStepIcon: {
            styleOverrides: {
                root: {
                    fontSize: variables.icon_size_sm,
                    color: "transparent",
                    border: `1px solid ${variables.border_subtle}`,
                    borderRadius: "50%",
                    "& .MuiStepIcon-text": {
                        fill: variables.text_medium,
                    },
                    "&.Mui-active": {
                        color: variables.interactive_selected,
                        border: "none",
                        "& .MuiStepIcon-text": {
                            fill: variables.text_inverse,
                        },
                    },
                    "&.Mui-completed": {
                        color: variables.feedback_success_fill,
                        border: "none",
                        fontSize: variables.icon_size_xs,
                    },
                },
            },
        },
        MuiStepLabel: {
            styleOverrides: {
                label: {
                    whiteSpace: "nowrap",
                    "&.Mui-active": {
                        color: variables.interactive_selected,
                    },
                    "&.Mui-disabled": {
                        color: variables.text_disabled,
                    },
                },
            },
        },
        MuiStepConnector: {
            styleOverrides: {
                line: {
                    borderColor: variables.border_subtle,
                },
            },
        },
    };
}
//# sourceMappingURL=stepper.js.map